import {Component} from 'react';
import h from 'react-hyperscript';
import BasicCard from 'Components/Cards/BasicCard';
import {h4} from 'Components/Typography/Typography';
import Sidebar from './Sidebar/Sidebar';
import MainContent from './MainContent/MainContent';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import {setZeroIfInvalidNumber, isArrayEmpty} from 'Src/utils/utils';
import ReportError from 'Components/ErrorMessage/ReportError';

import './FourCs.scss';

class FourCs extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      activeTab: 0,
      mobileAnchorEl: null,
      fourCs: null,
      isLoaded: false,
      weeklyDataByProduct: null,
      hasError: false,
    };
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleMobileMenuClose = this.handleMobileMenuClose.bind(this);
    this.handleMobileMenuOpen = this.handleMobileMenuOpen.bind(this);
  }

  componentWillMount() {
    this._isMounted = true;
    this.setData();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.districtMetrics !== prevProps.districtMetrics &&
      this.dataAvailable
    ) {
      this.setFourCsConfig();
    }
  }

  setData() {
    if (this.dataAvailable) {
      this.setFourCsConfig();
    } else {
      this.setHasError(true);
    }
  }

  get dataAvailable() {
    return (
      this.props.hasProductMetricsHistory &&
      !isArrayEmpty(this.props.gsuiteMetrics) &&
      this.props.districtMetrics &&
      typeof this.props.districtMetrics === 'object' &&
      this.props.districtMetrics.four_c_config &&
      !isArrayEmpty(this.props.products) &&
      !isArrayEmpty(this.props.sidebar)
    );
  }

  setHasError(value) {
    this.setState({
      isLoaded: true,
      hasError: value,
    });
  }

  setFourCsConfig() {
    if (this._isMounted) {
      this.setState(
          {
            fourCs: JSON.parse(this.props.districtMetrics.four_c_config),
          },
          () => {
            const weeklyDataByProduct = this.getWeeklyDataByProduct();
            this.setState(
                {
                  weeklyDataByProduct: weeklyDataByProduct,
                },
                () => {
                  this.setState({
                    isLoaded: true,
                  });
                }
            );
          }
      );
    }
  }

  getWeeklyDataByProduct() {
    const data = this.props.gsuiteMetrics.map((product) => {
      const weeklyData = product.metrics.map((week) => {
        return {
          product: product.id,
          productName: product.productName,
          productIcon: {
            standard: product.productIcon.standard,
            retina: product.productIcon.retina,
          },
          y: setZeroIfInvalidNumber(week.metric),
        };
      });
      return {
        product: product.id,
        data: weeklyData,
      };
    });
    return data;
  }

  handleTabClick(e) {
    e.preventDefault();
    this.setState({
      activeTab: e.currentTarget.getAttribute('datatab'),
    });
  }

  handleMobileMenuClose() {
    this.setState({
      mobileAnchorEl: null,
    });
  }

  handleMobileMenuOpen(e) {
    this.setState({
      mobileAnchorEl: e.currentTarget,
    });
  }

  render() {
    if (this.state.isLoaded) {
      return h(
          BasicCard,
          {
            id: this.props.id,
            className: this.props.className,
          },
          [
            h(
                TooltipGroup,
                {
                  title: this.props.titleTooltip,
                },
                h(
                    h4,
                    {
                      key: 'title__key',
                      className: 'card__title',
                    },
                    this.props.title
                )
            ),

          this.state.hasError ?
            h(
                'div',
                {
                  className: 'padding-bottom--md',
                },
                h(
                    ReportError,
                    {
                      message: this.props.noDataError,
                    },
                    null
                )
            ) :
            h(
                'div',
                {
                  key: 'flex-container',
                  className: 'flex flex--align-start flex--wrap',
                },
                [
                  h(
                      Sidebar,
                      {
                        key: 'four-c-sidebar',
                        items: this.props.sidebar,
                        activeTab: this.state.activeTab,
                        mobileAnchorEl: this.state.mobileAnchorEl,
                        handleTabClick: this.handleTabClick,
                        fourCs: this.state.fourCs,
                        handleMobileMenuClose: this.handleMobileMenuClose,
                        handleMobileMenuOpen: this.handleMobileMenuOpen,
                      },
                      null
                  ),

                  h(
                      'div',
                      {
                        key: 'four-c-tab-content',
                        className: 'padding-left--md',
                        id: 'four-cs__main-content',
                      },
                      this.props.sidebar.map((item, i) => {
                        const id = item.title.toLowerCase().replace(' ', '_');
                        const state = this.state;
                        const props = this.props;
                        return h(
                            MainContent,
                            {
                              key: `four-c-tab-content--${i}`,
                              i: i,
                              id: id,
                              item: item,
                              totalProducts: props.products,
                              activeTab: state.activeTab,
                              fourCs: state.fourCs[id],
                              currWindow: this.props.currWindow,
                              prevWindow: this.props.prevWindow,
                              data: props.data,
                              handleViewAll: this.handleViewAll,
                              weeklyDataByProduct: state.weeklyDataByProduct,
                              dynamicGraphSize: props.dynamicGraphSize,
                              screenWidth: props.screenWidth,
                            },
                            null
                        );
                      })
                  ),
                ]
            ),
          ]
      );
    } else {
      return h(LoadingIndicator, null, null);
    }
  }
}

export default FourCs;
